module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"HomepageBrands":{"heading":"Značky","linkAllBrands":"Všechny značky"}},"en":{"HomepageBrands":{"heading":"Brands","linkAllBrands":"All brands"}}}')
  delete Component.options._Ctor
}
